<template>
  <div class="fnss-card-item-vertical-item vux-1px-r">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>
